export const labelDefaultOptions = {
  value: '',
  column: '1/1',
}

export default labelDefaultOptions
